import ProfileCountries from "@/entities/locationEntities/ProfileCountries";

const isPrimaryCountry = (countryName: string): boolean =>
  Object.values(ProfileCountries).some((name) => name === countryName);

export default isPrimaryCountry;